import T from 'utils/T';
import ex from 'utils/ex';
import AverageGlycemicIndexBox from 'components/details/AverageGlycemicIndexBox';
import GMIBox from 'components/details/GMIBox';
import MBTIPatternBox from 'components/details/MBTIPatternBox';
import TIRBox from 'components/details/TIRBox';
import CVBox from 'components/details/CVBox';
import WeekendMBTIPatternBox from 'components/details/WeekendMBTIPatternBox';
import FocusableButton from 'components/common/FocusableButton';
import useNavigation from 'hooks/app/useNavigation';

export default function GlycemicIndexBox(props) {
  const {
    data,
    ...rest
  } = props;

  const { onPage: onPageApp } = useNavigation('App');
  const { onPage: onPageReport } = useNavigation('Report');

  return (
    <div {...ex('GlycemicIndexBox', rest)}>
      <AverageGlycemicIndexBox {...props}/>
      <CVBox {...props}/>
      <GMIBox {...props}/>
      <MBTIPatternBox {...props}/>
      <TIRBox {...props}/>
      <FocusableButton {...{ onClick: onPageReport('ReportBloodGlocose', onPageApp('Report')) }} />
    </div>
  );
}
